import "rxjs/add/operator/mergeMap";
import { Types, Creators } from "../reducer";

import * as firebase from "firebase";

export default (action$) =>
  action$.ofType(Types.ASSIGN_USER_TO_LANE).mergeMap((action) => {
    const userPath = `queues/${action.location}/${action.selectedUser.registrationId}`;
    const lanePath = `ranges/${action.location}/${action.range}/lane-${action.laneNumber}`;
    const [{ customer }] = action.selectedUser.group;
    const customerSignInPath = `customers/${customer}/signIns/${action.location}/${action.range}/${action.selectedUser.registrationId}`;

    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(userPath)
        .once("value")
        .then((snapshot) => {
          const updatePromise = firebase
            .database()
            .ref(lanePath)
            .update({
              status: "in-use",

              assignment: {
                ...snapshot.val(),
                registrationId: action.selectedUser.registrationId,
                created: Date.now(),
                updated: Date.now(),
              },
            });

          const removePromise = firebase.database().ref(userPath).remove();
          // A group member without a customer id would otherwise land in customers/undefined.
          const updateCustomerPromise = customer
            ? firebase
                .database()
                .ref(customerSignInPath)
                .update({
                  line: action.laneNumber,
                  checkInAt: Date.now(),
                })
            : Promise.resolve();

          Promise.all([updatePromise, removePromise, updateCustomerPromise])
            .then(() => resolve(Creators.assignUserToLaneSucceeded()))
            .catch(() => reject(Creators.assignUserToLaneFailed()));
        })
        .catch(() => reject(Creators.assignUserToLaneFailed()));
    });
  });



// WEBPACK FOOTER //
// ./src/staff/epics/assignUserToLane.js